module.exports = __webpack_public_path__ + "static/media/howItWork2.2aeb0969.png";